import { render, staticRenderFns } from "./ShortText.vue?vue&type=template&id=2404d058&scoped=true&"
import script from "./ShortText.vue?vue&type=script&lang=js&"
export * from "./ShortText.vue?vue&type=script&lang=js&"
import style0 from "./ShortText.vue?vue&type=style&index=0&id=2404d058&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404d058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
